<template>
    <div>
        <div class="page-banner">
            <h1 v-html="pageTitle" :class="[this.currentLanguage == 'AR' ? 'rtlText': '']"></h1>
        </div>
        <div class="page-content">
            <div class="page-content__inner">
                <div class="contacts">
                    <p class="contacts__intro"
                       :class="[this.currentLanguage == 'AR' ? 'rtlText': '']">
                        {{ $t('contact.title') }}</p>
                    <div class="contacts__list"
                         :class="[this.currentLanguage == 'AR' ? 'rtlText': '']">
                        <div class="list-item" v-for="contact in contactInfos" :key="contact.order">
                            <p>{{ getSeparationLabel(contact.content) }}</p>
                            <span>{{ getSeparationText(contact.content) }}</span>
                        </div>
                    </div>
                    <div class="contacts__intro"
                         :class="[this.currentLanguage == 'AR' ? 'rtlText': '']"
                         v-if="$t('contact.afterList') != 'contact.afterList'"
                         v-html="$t('contact.afterList')">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {helpers} from '../helper/portal_config';

const apiMethod = 'getPortalContact';

export default {
    name: 'ContactUs',
    title: `${helpers.portal_name} Contact`,
    data() {
        return {
            pageTitle: this.$i18n.t('contactus'),
            contactInfos: [],
            currentLanguage: "",
            currentCountry: "",
        };
    },
    methods: {
        setCurrentCountry() {
            const {host} = window.location;
            this.currentCountry = host.split('.')[0].slice(0, 2).toUpperCase();
        },
        setCurrentLanguage() {
            var lang = "";
            const {host} = window.location;
            var country = host.split('.')[0].slice(0, 2).toUpperCase();
            if (helpers.countryDefaultLanguage.hasOwnProperty(country)) {
                lang = helpers.countryDefaultLanguage[country].toUpperCase();
            } else {
                lang = country.toUpperCase();
            }
            this.currentLanguage = lang;
        },
        getSeparationLabel(value) {
            if (!value) return '';
            return value.split(':')[0];
        },
        getSeparationText(value) {
            if (!value) return '';
            return value.split(':')[1]?.trim() ?? '';
        },
    },
    mounted() {
        this.setCurrentLanguage();
        this.setCurrentCountry();

        axios
            .get(
                `${helpers.API_BASE_URL}/store/${apiMethod}?portal_name=${helpers.portal_name}&country=${this.currentCountry}&language=${this.currentLanguage}`,
            )
            .then((response) => {
                if (response.data.treatment === 1) {
                    this.contactInfos = response.data.contact;
                }
            });
    },
};
</script>
